import { Skeleton } from "@/components/ui/skeleton.tsx";
import { formatCount, formatShortDate } from "../../utils/format.ts";
import type { LeafStage } from "../../utils/schedule.ts";

const MAX_STAGES = 10;

export interface InProgressStagesProps {
	variant: "count" | "list";
	stages?: LeafStage[];
	isPending: boolean;
	isError: boolean;
}

export function InProgressStages({
	variant,
	stages,
	isPending,
	isError,
}: InProgressStagesProps) {
	if (isPending) {
		return <Skeleton className="in-progress-skeleton" />;
	}

	if (isError || !stages) {
		return (
			<p className="dashboard-panel-error" role="status">
				Não foi possível carregar as etapas em andamento.
			</p>
		);
	}

	if (variant === "count") {
		return (
			<div className="in-progress-count">
				<p className="in-progress-count__value">{formatCount(stages.length)}</p>
				<p className="in-progress-count__label">
					{stages.length === 1
						? "etapa em andamento nesta obra"
						: "etapas em andamento nesta obra"}
				</p>
			</div>
		);
	}

	if (stages.length === 0) {
		return (
			<p className="dashboard-panel-empty" role="status">
				Nenhuma etapa em andamento.
			</p>
		);
	}

	return (
		<ul className="in-progress-list">
			{stages.slice(0, MAX_STAGES).map((stage) => (
				<li key={stage.stageId} className="in-progress-stage">
					<span className="in-progress-stage__name">{stage.name}</span>
					<span className="in-progress-stage__deadline">
						{stage.plannedEndDate
							? `Fim previsto: ${formatShortDate(stage.plannedEndDate)}`
							: "Sem fim previsto"}
					</span>
				</li>
			))}
		</ul>
	);
}
